import { useNavigate } from 'react-router-dom';
import { GovIcon } from '@gov-design-system-ce/react';
import { useLocale } from '@gov-nx/core/service';
import {
	DataBoxFolderType,
	useDataBoxMessageDetailContext,
} from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button, Dialog } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';

export const DataBoxMessageVaultConfirmModal = () => {
	const { t } = useLocale(PageCode['datove-schranky']);

	const {
		dataBoxId,
		folderType,
		messageOperations: { handleDeleteMessageFromVault },
		vaultConfirmModal,
		loadingItems,
	} = useDataBoxMessageDetailContext();

	const navigate = useNavigate();

	const redirect = () => {
		navigate(
			pageRouteResolver('datove-schranky.schranka', {
				dataBoxId,
				folderType,
			})
		);
	};

	return (
		<Dialog
			isOpen={vaultConfirmModal.value}
			onClose={vaultConfirmModal.setFalse}
			icon={
				<GovIcon
					name="exclamation-triangle-fill"
					type="components"
					className="text-error-400"
				/>
			}
			title={<h3>{t('zpravy.detail.odstranit-z-datoveho-trezoru')}</h3>}
			footer={
				<>
					<Button
						nativeType="button"
						color="primary"
						type="base"
						size="m"
						onClick={vaultConfirmModal.setFalse}
						aria-label={t('zpravy.zrusit')}>
						{t('zpravy.zrusit')}
					</Button>
					<Button
						nativeType="button"
						color="error"
						type="outlined"
						size="m"
						isLoading={loadingItems.deleteFromVault}
						onClick={() =>
							handleDeleteMessageFromVault(
								folderType === DataBoxFolderType.Received
									? 'PRIJATA'
									: 'ODESLANA',
								redirect
							)
						}
						isDisabled={!!loadingItems.deleteFromVault}
						aria-label={t('zpravy.detail.odstranit-z-datoveho-trezoru')}>
						{t('zpravy.detail.odstranit-z-datoveho-trezoru')}
					</Button>
				</>
			}>
			<p>{t('zpravy.detail.odstranit-z-datoveho-trezoru-description')}</p>
		</Dialog>
	);
};
